import React from "react";
import "./LoadCard.css";
/**Firebase Imports**/
import { auth, db, collection, setDoc, doc } from "../../../firebaseConfig";
import { showError } from "../../../helpers/showError";

const LoadCard = ({
	array,
	updateLoads,
	setUpdateLoads,
	index,
	name,
	rate,
	miles,
}) => {
	const loadsRef = collection(db, "weekly_loads");
	const handleDelete = async () => {
		var arrTemp = array.filter((x, i) => i !== index);
		await setDoc(doc(loadsRef, auth.currentUser.uid), {
			loads: arrTemp,
		})
			.then(() => {
				//loads updated
				setUpdateLoads(!updateLoads);
				console.log("item at index " + index + " deleted");
			})
			.catch((error) => {
				showError(error);
			});
	};

	return (
		<div className="LoadCard">
			<div className="card relative">
				<img
					className="absolute top-4 right-3 h-5"
					src={require("../../../images/deleteIcon.png")}
					alt="delete_icon"
					onClick={() => handleDelete()}
				/>
				<p className="load">{name}</p>
				<p className="rateMiles">Rate: ${rate}</p>
				<p className="rateMiles">Miles: {miles}</p>
				<p className="ratePerMiles">
					<span className="w-1/2">
						Rate Per <br /> Mile:
					</span>
					<span className="w-1/2 text-right pl-1">
						${(rate / miles).toFixed(2)}
					</span>
				</p>
			</div>
		</div>
	);
};

export default LoadCard;
